export enum ToolId {
	Portfolio = 'Portfolio',
	Development = 'Development',
	Leasing_and_Transactions = 'Leasing and Transactions',
	Space = 'Space',
	Maintenance = 'Maintenance',
	Sustainability = 'Sustainability',
	Market_Intelligence = 'Market Intelligence',
	Alternative_Data = 'Alternative Data',
}